import { apiRequest } from '@/Groups/Signals/private/imports/externalUtils';

//Добавить / убрать сигнал из избранного
export const apiToggleFavouriteSignal = ({ object_id, content_type }) =>
  apiRequest('/api/reactions/bookmarks/create/', {
    method: 'POST',
    body: JSON.stringify({ object_id, content_type }),
  });